const createAssessment = async (userAction) => {
  const urlCreateAssessment = `${process.env.VUE_APP_URL_CF_RECAPTCHA}/api-recaptcha-servi/check-token`
  const response = await fetch(urlCreateAssessment, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(userAction),
  });

  let responseCreateAssessment = await response.json();
  return responseCreateAssessment;
};

const anotateAssessment = async (userAnotate) => {
  const urlAnotateAssessment = `${process.env.VUE_APP_URL_CF_RECAPTCHA}/api-recaptcha-servi/annotate-assessment`
  const response = await fetch(urlAnotateAssessment, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(userAnotate),
  });

  let responseAnotateAssessment = await response.json();
  return responseAnotateAssessment;
};

export default {
  createAssessment,
  anotateAssessment
};
